module.exports = __webpack_public_path__ + "img/testAnalysis_b.37a1791f.png";